import { createFileRoute } from '@tanstack/react-router'
import { NotificationsPage } from '@/features/notifications'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customer/notifications')({
  component: NotificationsPage,
  beforeLoad: requireRole(['customer']),
})
